import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons"
import { useNavigate, useParams } from 'react-router-dom'
import { useGetCompaniesQuery } from './companiesApiSlice'
import { memo } from 'react'

const Company = ({ companyId }) => {
    const {groupId, type} = useParams()
    const { company } = useGetCompaniesQuery("companiesList", {
        selectFromResult: ({ data }) => ({
            company: data?.entities[companyId]
        }),
    })

    const navigate = useNavigate()

    if (company) {
        const handleEdit = () => navigate(`/${type}/${groupId}/companies/${companyId}`)

        return (
            <tr className="table__row">
                <td className="table__cell company__name">{company.name}</td>
                <td className="table__cell company__active">{company.active?"true":"false"}</td>

                <td className="table__cell">
                    <button
                        className="icon-button table__button"
                        onClick={handleEdit}
                    >
                        <FontAwesomeIcon icon={faPenToSquare} />
                    </button>
                </td>
            </tr>
        )

    } else return null
}

const memoizedCompany = memo(Company)

export default memoizedCompany